export default class PageImpl<T> {
    private _content: T[] = [];
    private _pageNumber: number;
    private _totalPages: number;
    private _message: string;
    private _status: string;
    private _totalLastYearValue: number;
    private _totalYearValue: number;
    private _totalMonthValue: number;

    constructor(content: T[] = [], pageNumber = 0, totalPages = 0, message = '', status = '',
        totalLastYearValue = 0, totalYearValue = 0, totalMonthValue = 0) {
        this._message = message;
        this._content = content;
        this._pageNumber = pageNumber;
        this._totalPages = totalPages;
        this._message = message;
        this._status = status;
        this._totalLastYearValue = totalLastYearValue;
        this._totalYearValue = totalYearValue;
        this._totalMonthValue = totalMonthValue;
    }

    get content(): T[] {
        return this._content;
    }

    get pageNumber(): any {
        return this._pageNumber;
    }

    get totalPages(): number {
        return this._totalPages;
    }

    get message(): string {
        return this._message;
    }

    get status(): string {
        return this._status;
    }

    get totalLastYearValue(): number {
        return this._totalLastYearValue;
    }

    get totalYearValue(): number {
        return this._totalYearValue;
    }

    get totalMonthValue(): number {
        return this._totalMonthValue;
    }
}